import { render } from "./NavigationDrawer.vue?vue&type=template&id=5a8b1f42&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=5a8b1f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8b1f42"]])

export default __exports__